var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"c-black btn btn-outline-orange w-150px",attrs:{"href":_vm.linkedInUrl,"alt":"Linkedin","target":"_blank"}},[_c('i',{staticClass:"fab fa-linkedin-in fs-25 mr-3"}),_vm._v("\n    LinkedIn\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }